<template>
  <router-view></router-view>
</template>

<script>
  import store from '@/page/store'

  export default {
    provide() {
      return { store };
    },

    data () {
      return {
        banner: null
      }
    },

    // watch: {
    //   '$route.path'(path) {
    //     this._bindRoute(path);
    //   }
    // },

    // created() {
    //   this._bindRoute(this.$route.path);
    // },

    // methods: {
    //   _bindRoute(path) {
    //     if (path === '/') {
    //       this.$router.push('/home');
    //     }
    //   }
    // }
  };
</script>
